import { Button, Card, Select, Typography } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { RoomContext } from "../../RoomContext";
import Room from "../Room/Room";
import VideoDevices from "../VideoDevices";
import { createLocalTracks, createLocalVideoTrack } from "twilio-video";

const { Meta } = Card;

const Lobby = ({
  title,
  description,
  cover,
  loading,
  identity,
  roomName,
  children,
}) => {
  const { connectToRoom, connecting, room } = useContext(RoomContext);

  useEffect(() => {
    // getTracks();
  }, []);

  const getTracks = async () => {
    let tracks = await createLocalTracks();
    console.log(tracks);
  };

  return !room ? (
    <div className="carisity-lobby">
      <Card
        // cover={cover}
        style={{ maxWidth: "400px", minWidth: "200px" }}
        actions={[
          <Button
            type="primary"
            onClick={() => connectToRoom(identity, roomName)}
            disabled={connecting}
          >
            {connecting ? "Connecting" : "Join"}
          </Button>,
        ]}
        loading={loading}
        title={<>{title || "lobby"}</>}
      >
        <VideoDevices />
        {children}
      </Card>
    </div>
  ) : (
    <Room />
  );
};

export default Lobby;
